import { BrLoading } from '@govbr-ds/react-components';
import style from './customLoading.module.scss';
import { ReactNode } from 'react';

function CustomLoading({ label, children }: { label: string; children?: ReactNode }) {
  return (
    <div className={style.container}>
      <BrLoading large label={label} />
      {children}
    </div>
  );
}

export default CustomLoading;
